import { TriangleAlertIcon } from 'components/icons/TriangleAlert'
import { useTranslationTyped } from 'i18n/i18n'

export function SettingsWarningBox() {
  const { tt } = useTranslationTyped()
  return (
    <div className="mb-5 flex flex-row items-center justify-start gap-3 self-stretch rounded-xl border border-solid border-outline-light bg-core-on-primary px-5 py-3">
      <TriangleAlertIcon
        className="stroke-core-error"
        size={32}
        strokeWidth={2.5}
      />
      <div className="text-body-medium">
        {tt.lti.configuration.billing_settings_warning()}
      </div>
    </div>
  )
}
